<section class="line-item-modal-container">
    <div class="modal-header d-block">
        <h5 class="modal-title">
            {{title}}
        </h5>
        <p class="mb-0 small">You will only have permission to view the content of the role you select.</p>
    </div>
    <div class="modal-body">
        <div class="row justify-content-center mb-3">
            <div class="card col-auto mx-3 cursor-pointer my-2" *ngFor="let role of roles"
                title="{{role}}"
                (click)="closeModal(role)">
                <div class="mb-2">
                    <span ngClass="{{userRoles[role]}}"></span>
                </div>
                <h6 class="card__title">
                    {{role}}
                </h6>
            </div>
       </div>
    </div>
</section>